import { render, staticRenderFns } from "./SkiRunField.vue?vue&type=template&id=4ca93117&scoped=true"
import script from "./SkiRunField.vue?vue&type=script&lang=js"
export * from "./SkiRunField.vue?vue&type=script&lang=js"
import style0 from "./SkiRunField.vue?vue&type=style&index=0&id=4ca93117&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca93117",
  null
  
)

export default component.exports